import { FC } from "hoist-non-react-statics/node_modules/@types/react";

export const ResponsiveFirstLevelNav: FC = ({ children }) => (
  <>
    <ul className="nav nav-tabs flex-row d-none d-sm-flex mb-5">{children}</ul>
    <ul className="nav nav-pills flex-column d-flex d-sm-none mb-5">
      {children}
    </ul>
  </>
);

export const ResponsiveSecondLevelNav: FC = ({ children }) => (
  <>
    <ul className="nav flex-column nav-pills d-none d-lg-flex">{children}</ul>
    <ul className="nav d-flex flex-row flex-wrap d-lg-none mb-6">{children}</ul>
  </>
);
